import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SectionWrapper from "../components/SectionWrapper";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import { ImCross } from "react-icons/im";

const MembershipPage = () => {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [coreServices, setCoreServices] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const formatFeatureValue = (value) =>
    typeof value === "string" ? value.replace(/^\u2705\s*/, "") : "";

  useEffect(() => {
    fetch("/AllJson/annualpackages_10.json", { cache: "force-cache" })
      .then((res) => res.json())
      .then((data) => setPackages(data.annualPackages))
      .catch((err) => console.error("Error loading packages:", err));
  }, []);

  useEffect(() => {
    fetch("/AllJson/coreservices.json", { cache: "force-cache" })
      .then((res) => res.json())
      .then((data) => {
        const original = data.CoreServices;
        setCoreServices([...original, ...original, ...original]);
      })
      .catch((err) => console.error("Error loading Core Services:", err));
  }, []);

  const getVisibleItems = () => {
    if (window.innerWidth < 640) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  };

  const [visibleItems, setVisibleItems] = useState(getVisibleItems());

  useEffect(() => {
    const handleResize = () => setVisibleItems(getVisibleItems());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev >= coreServices.length - visibleItems ? 0 : prev + 1
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [coreServices, visibleItems]);

  const totalItems = coreServices.length;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev >= coreServices.length - visibleItems ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? coreServices.length - visibleItems : prev - 1
    );
  };

  const handleSubscribeNow = () => {
    navigate("/contact");
  };

  return (
    <div className="mt-20 mb-0">
      <SectionWrapper className="bg-gradient-to-r from-[#658297] to-[#325575] py-16 text-white">
        <div className="mx-auto mt-4 mb-12 max-w-3xl rounded-[2rem] border border-white/15 bg-white/10 px-6 py-8 text-center shadow-[0_24px_80px_rgba(0,0,0,0.18)] backdrop-blur-md md:px-10">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl">
            Yearly Plans
          </h2>
          <p className="mt-3 text-base text-white/85 md:text-xl">
            Choose the perfect plan for your family's needs
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              className={`flex flex-col justify-between rounded-[1.75rem] border border-white/70 bg-gradient-to-b from-white via-white to-slate-50 p-8 text-slate-800 shadow-[0_18px_50px_rgba(15,23,42,0.12)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_26px_70px_rgba(15,23,42,0.16)] ${
                pkg.name === "Premium" ? "ring-2 ring-yellow-400/80" : ""
              }`}
            >
              <div>
                <div className="text-center">
                  {pkg.name === "Premium" && (
                    <div className="mx-auto mb-4 inline-flex rounded-full bg-maroon px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-white shadow-sm">
                      Most Popular
                    </div>
                  )}

                  <h3 className="text-2xl font-bold tracking-tight text-[#2c5779]">
                    {pkg.name} Plan
                  </h3>

                  <div className="mt-4 text-4xl font-extrabold text-slate-700">
                    {pkg.price}
                  </div>
                </div>

                <ul className="mt-8 space-y-3 text-gray-700">
                  {Object.entries(pkg.features).map(([feature, value], i) => (
                    <li
                      key={i}
                      className="flex items-start gap-3 rounded-2xl border border-slate-100/80 bg-white/80 px-4 py-3 shadow-sm transition hover:border-maroon/10 hover:bg-maroon/5"
                    >
                      {value ? (
                        <FaCheckCircle className="mt-0.5 shrink-0 text-lg text-emerald-500" />
                      ) : (
                        <ImCross className="mt-0.5 shrink-0 text-lg text-red-600" />
                      )}

                      <span>
                        {feature}:
                        <span className="font-semibold text-slate-900">
                          {formatFeatureValue(value)}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              <button
                onClick={handleSubscribeNow}
                className="mt-8 w-full rounded-full bg-gradient-to-r from-[#2c5779] to-[#18324a] py-3.5 font-semibold text-white shadow-[0_12px_30px_rgba(44,87,121,0.28)] transition-all duration-300 hover:from-[#244968] hover:to-[#13293b] hover:shadow-[0_16px_36px_rgba(44,87,121,0.34)]"
              >
                Subscribe Now
              </button>
            </div>
          ))}
        </div>

        <div className="w-full py-8 lg:mx-auto">
          <h1 className="py-4 text-center text-3xl font-extrabold tracking-wide text-white md:text-4xl">
            Exclusive Wellness Benefits
          </h1>

          <div className="mt-6 flex items-center justify-between lg:gap-2">
            <button
              onClick={prevSlide}
              className="rounded-full bg-white p-1 text-maroon shadow-lg transition hover:scale-110 lg:p-3"
            >
              <IoIosArrowDropleft className="size-6 lg:size-7" />
            </button>

            <div className="w-full overflow-hidden lg:gap-1">
              <div
                className="flex transition-transform duration-700"
                style={{
                  width: `${totalItems * (100 / visibleItems)}%`,
                  transform: `translateX(-${(100 / totalItems) * currentIndex}%)`,
                }}
              >
                {coreServices.map((s, i) => (
                  <div key={i} className="mx-1 w-full lg:w-1/4">
                    <div className="flex h-full w-full flex-col rounded-2xl border border-white/70 bg-white p-4 text-center shadow-[0_12px_35px_rgba(15,23,42,0.12)] transition hover:-translate-y-1 hover:shadow-[0_18px_45px_rgba(15,23,42,0.16)]">
                      <div className="mb-4 flex h-60 w-full items-center justify-center overflow-hidden rounded-xl bg-slate-50">
                        <img
                          src={s.image}
                          alt={s.heading}
                          className="h-full w-full object-cover"
                        />
                      </div>

                      <div>
                        <h1 className="text-lg font-semibold text-maroon">
                          {s.heading}
                        </h1>
                        <p className="mt-1 text-sm text-gray-600">
                          {s.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={nextSlide}
              className="rounded-full bg-white p-1 text-maroon shadow-lg transition hover:scale-110 lg:p-3"
            >
              <IoIosArrowDropright className="size-6 lg:size-7" />
            </button>
          </div>
        </div>

      </SectionWrapper>
    </div>
  );
};

export default MembershipPage;
